import type { LinkProps } from '@mui/material/Link';
import MuiLink from '@mui/material/Link';
import type { LinkProps as RemixLinkProps } from '@remix-run/react';
import { Link, useSearchParams } from '@remix-run/react';
import * as React from 'react';
import { getHrefWithLogoQuery } from '~/utils/common';

export const RemixLink = React.forwardRef<any, Omit<RemixLinkProps, 'to'> & { href: RemixLinkProps['to'] }>(
  (props, ref) => {
    const { href, children, ...rest } = props;
    // Map href (MUI) -> to (react-router)
    return (
      <Link ref={ref} to={href} {...rest}>
        {children}
      </Link>
    );
  }
);
RemixLink.displayName = 'LinkBehavior';

// see https://mui.com/material-ui/guides/routing/#global-theme-link
// for a possible improvement using LinkBehavior directly in the theme
// and as the default component prop of the Mui Link component
// TODO: this export should be in another file (TBD)
export const MuiRemixLink = React.forwardRef(({ children, ...rest }: LinkProps & Omit<RemixLinkProps, 'to'>, ref) => {
  const [searchParams] = useSearchParams();

  const hrefWithQuery = getHrefWithLogoQuery(searchParams, rest.href);

  return (
    <MuiLink ref={ref} component={RemixLink} {...rest} href={hrefWithQuery}>
      {children}
    </MuiLink>
  );
});
MuiRemixLink.displayName = 'MuiRemixLink';
